// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bw-text: #13231D;
  --bw-text-secondary: rgba(19, 35, 29, 0.68);
  --bw-text-tertiary: rgba(19, 35, 29, 0.46);
  --bw-primary: #82B194;
  --base-container: 1280px;
  --gutter-desktop: 40px;
  --gutter-tablet: 28px;
  --gutter-mobile: 20px;
  --border-soft: rgba(19, 35, 29, 0.08);
  --border-mid: rgba(19, 35, 29, 0.22);
  --radius-card: 32px;
  --radius-card-sm: 24px;
  --radius-button: 20px;
  --radius-button-header: 18px;
  --shadow-soft: 0 18px 48px rgba(18, 34, 29, 0.04);
}

.ProfessionalsSection_pros-section__n7H2i {
  padding: 72px 40px;
  background-color: transparent;
  max-width: 1280px;
  margin: 0 auto;
  font-family: "Sora", system-ui, -apple-system, "Segoe UI", Roboto, Arial, sans-serif;
}
@media (max-width: 1024px) {
  .ProfessionalsSection_pros-section__n7H2i {
    padding: 48px 40px;
  }
}
@media (max-width: 768px) {
  .ProfessionalsSection_pros-section__n7H2i {
    padding: 40px 20px;
  }
}
.ProfessionalsSection_pros-section__card__IIEI9 {
  border-radius: 16px;
  background-color: #F7F5F1;
  box-shadow: 0 12px 28px rgba(14, 42, 34, 0.08);
  padding: 52px 56px 36px;
  display: flex;
  flex-direction: column;
}
@media (max-width: 768px) {
  .ProfessionalsSection_pros-section__card__IIEI9 {
    padding: 32px 20px 24px;
  }
}
.ProfessionalsSection_pros-section__eyebrow__Fhq-S {
  display: block;
  font-size: 13px;
  font-weight: 700;
  color: #739F84;
  letter-spacing: 0.14em;
  margin-bottom: 12px;
  text-transform: uppercase;
  line-height: 1.35;
}
.ProfessionalsSection_pros-section__title__flfqe {
  font-weight: 800;
  font-size: 48px;
  line-height: 1.04;
  margin-bottom: 20px;
  color: #3B3B3D;
}
@media (max-width: 768px) {
  .ProfessionalsSection_pros-section__title__flfqe {
    font-size: 32px;
    margin-bottom: 16px;
  }
}
.ProfessionalsSection_pros-section__title-line__h3Ipt {
  display: block;
  white-space: nowrap;
}
@media (max-width: 768px) {
  .ProfessionalsSection_pros-section__title-line__h3Ipt {
    white-space: normal;
  }
}
.ProfessionalsSection_pros-section__copy__CLeWP {
  font-size: 16px;
  line-height: 1.65;
  color: #4A4A4A;
  margin-top: 0;
  margin-bottom: 0;
  max-width: 700px;
}
.ProfessionalsSection_pros-section__action-row__DrbSf {
  display: flex;
  justify-content: flex-end;
  grid-column: 1/-1;
}
@media (max-width: 980px) {
  .ProfessionalsSection_pros-section__action-row__DrbSf {
    grid-column: 1;
    grid-row: auto;
    justify-content: flex-start;
    margin-top: 18px;
  }
}
.ProfessionalsSection_pros-section__btn-secondary__KqYof {
  min-width: 300px;
  min-height: 46px;
  border-radius: 16px;
  border: 1px solid rgba(130, 177, 148, 0.55);
  background: transparent;
  color: rgba(16, 25, 21, 0.84);
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s;
  line-height: 1.2;
  font-size: 15px;
  letter-spacing: -0.01em;
  margin-top: 16px;
}
@media (max-width: 1080px) {
  .ProfessionalsSection_pros-section__btn-secondary__KqYof {
    width: 100%;
    min-width: unset;
  }
}
.ProfessionalsSection_pros-section__btn-secondary__KqYof:hover {
  background: rgba(130, 177, 148, 0.1);
  border-color: rgba(130, 177, 148, 0.7);
}
.ProfessionalsSection_pros-section__carousel__5jH5i {
  grid-column: 1/-1;
  width: 100%;
  margin-top: 28px;
  position: relative;
  border: 1px solid rgba(12, 36, 28, 0.08);
  background: rgba(255, 255, 255, 0.36);
  border-radius: 24px;
  padding: 28px 32px 24px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.03);
}
@media (max-width: 1024px) {
  .ProfessionalsSection_pros-section__carousel__5jH5i {
    padding: 24px 24px 20px;
  }
}
@media (max-width: 768px) {
  .ProfessionalsSection_pros-section__carousel__5jH5i {
    padding: 20px;
    margin: 20px -20px 0;
    width: calc(100% + 40px);
    border-radius: 0;
    border-left: none;
    border-right: none;
    background: transparent;
    box-shadow: none;
  }
}
.ProfessionalsSection_pros-section__track__4w20C {
  display: flex;
  gap: 16px;
  overflow-x: auto;
  overflow-y: hidden;
  scroll-behavior: smooth;
  scroll-snap-type: x mandatory;
  padding: 0;
  margin: 0;
  scrollbar-width: none;
}
.ProfessionalsSection_pros-section__track__4w20C::-webkit-scrollbar {
  display: none;
}
.ProfessionalsSection_pros-section__pro-card__Raq-f {
  position: relative;
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: calc((100% - 48px) / 4);
  min-width: calc((100% - 48px) / 4);
  height: 360px;
  scroll-snap-align: start;
  border-radius: 24px;
  overflow: hidden;
  background: #ddd;
  box-shadow: 0 12px 28px rgba(14, 42, 34, 0.08);
  cursor: pointer;
}
@media (max-width: 1180px) {
  .ProfessionalsSection_pros-section__pro-card__Raq-f {
    flex-basis: calc((100% - 32px) / 3);
    min-width: calc((100% - 32px) / 3);
  }
}
@media (max-width: 980px) {
  .ProfessionalsSection_pros-section__pro-card__Raq-f {
    flex-basis: calc((100% - 16px) / 2);
    min-width: calc((100% - 16px) / 2);
  }
}
@media (max-width: 780px) {
  .ProfessionalsSection_pros-section__pro-card__Raq-f {
    flex-basis: 82vw;
    min-width: 82vw;
    height: 400px;
  }
}
@media (max-width: 768px) {
  .ProfessionalsSection_pros-section__pro-card__Raq-f {
    height: 420px;
    flex-basis: 100%;
    min-width: 100%;
    scroll-snap-align: center;
  }
}
.ProfessionalsSection_pros-section__pro-card__Raq-f::before {
  content: none;
}
.ProfessionalsSection_pros-section__pro-card__Raq-f:hover .ProfessionalsSection_pros-section__pro-card__card-cta__BJ9-7, .ProfessionalsSection_pros-section__pro-card__Raq-f:focus-within .ProfessionalsSection_pros-section__pro-card__card-cta__BJ9-7 {
  opacity: 1;
  transform: translateX(-50%) translateY(0);
}
.ProfessionalsSection_pros-section__dim-tag__uHWr4 {
  position: absolute;
  top: 14px;
  left: 14px;
  z-index: 5;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 28px;
  padding: 0 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  background: color-mix(in srgb, var(--dimension-color) 14%, white 86%);
  color: var(--dimension-color);
  border: 1px solid color-mix(in srgb, var(--dimension-color) 32%, white 68%);
  backdrop-filter: blur(4px);
}
.ProfessionalsSection_pros-section__pro-media__UNrHM {
  position: absolute;
  inset: 0;
  background-size: cover;
  background-position: center;
  filter: saturate(0.94) contrast(1.04);
}
.ProfessionalsSection_pros-section__pro-media__UNrHM::after {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.84) 0%, rgba(0, 0, 0, 0.58) 24%, rgba(0, 0, 0, 0.22) 52%, rgba(0, 0, 0, 0) 76%);
}
.ProfessionalsSection_pros-section__pro-overlay__iqriY {
  position: absolute;
  left: 16px;
  right: 16px;
  bottom: 26px;
  z-index: 4;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  justify-content: flex-end;
  min-height: calc(100% - 32px);
  pointer-events: none;
}
.ProfessionalsSection_pros-section__card-cta__lEkSF {
  position: absolute;
  left: 50%;
  bottom: 116px;
  transform: translateX(-50%) translateY(8px);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 40px;
  padding: 0 16px;
  border-radius: 14px;
  font-size: 13px;
  font-weight: 800;
  text-decoration: none;
  color: #13231D;
  background: rgba(247, 245, 241, 0.97);
  border: 1px solid rgba(12, 36, 28, 0.08);
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.18);
  opacity: 0;
  transition: opacity 0.18s ease, transform 0.18s ease, background 0.15s ease;
  pointer-events: auto;
  white-space: nowrap;
  z-index: 10;
}
.ProfessionalsSection_pros-section__card-cta__lEkSF:hover {
  background: #F7F5F1;
}
.ProfessionalsSection_pros-section__pro-card__Raq-f:hover .ProfessionalsSection_pros-section__card-cta__lEkSF {
  opacity: 1;
  transform: translateX(-50%) translateY(0);
}
.ProfessionalsSection_pros-section__card-cta__lEkSF {
  position: absolute;
  left: 50%;
  bottom: 116px;
  transform: translateX(-50%) translateY(8px);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 40px;
  padding: 0 16px;
  border-radius: 14px;
  font-size: 13px;
  font-weight: 800;
  text-decoration: none;
  color: #13231D;
  background: rgba(247, 245, 241, 0.97);
  border: 1px solid rgba(12, 36, 28, 0.08);
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.18);
  opacity: 0;
  transition: opacity 0.18s ease, transform 0.18s ease, background 0.15s ease;
  pointer-events: auto;
  white-space: nowrap;
  z-index: 10;
}
.ProfessionalsSection_pros-section__card-cta__lEkSF:hover {
  background: #F7F5F1;
}
.ProfessionalsSection_pros-section__pro-card__Raq-f:hover .ProfessionalsSection_pros-section__card-cta__lEkSF {
  opacity: 1;
  transform: translateX(-50%) translateY(0);
}
.ProfessionalsSection_pros-section__card-cta__lEkSF {
  position: absolute;
  left: 50%;
  bottom: 116px;
  transform: translateX(-50%) translateY(8px);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 40px;
  padding: 0 16px;
  border-radius: 14px;
  font-size: 13px;
  font-weight: 800;
  text-decoration: none;
  color: #13231D;
  background: rgba(247, 245, 241, 0.97);
  border: 1px solid rgba(12, 36, 28, 0.08);
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.18);
  opacity: 0;
  transition: opacity 0.18s ease, transform 0.18s ease, background 0.15s ease;
  pointer-events: auto;
  white-space: nowrap;
  z-index: 10;
}
.ProfessionalsSection_pros-section__card-cta__lEkSF:hover {
  background: #F7F5F1;
}
.ProfessionalsSection_pros-section__pro-card__Raq-f:hover .ProfessionalsSection_pros-section__card-cta__lEkSF {
  opacity: 1;
  transform: translateX(-50%) translateY(0);
}
.ProfessionalsSection_pros-section__pro-copy__6HY5A {
  min-height: 104px;
  margin-top: auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
.ProfessionalsSection_pros-section__pro-name__YrPIo {
  margin: 0;
  min-height: 48px;
  display: flex;
  align-items: flex-end;
  color: #fff;
  font-size: 22px;
  line-height: 1.08;
  font-weight: 700;
  letter-spacing: -0.01em;
  text-shadow: 0 8px 16px rgba(0, 0, 0, 0.34);
}
.ProfessionalsSection_pros-section__pro-role__ETxsH {
  margin: 6px 0 0;
  min-height: 30px;
  display: flex;
  align-items: flex-start;
  color: rgba(255, 255, 255, 0.94);
  font-size: 12px;
  line-height: 1.25;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  text-shadow: 0 8px 16px rgba(0, 0, 0, 0.34);
}
.ProfessionalsSection_pros-section__msp-badge__aZdJA {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  align-self: flex-start;
  width: auto;
  min-width: 0;
  margin-top: 10px;
  min-height: 20px;
  padding: 0 8px;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.42);
  background: rgba(0, 0, 0, 0.18);
  color: #fff;
  font-size: 9px;
  line-height: 1;
  font-weight: 800;
  letter-spacing: 0.02em;
  backdrop-filter: blur(6px);
}
.ProfessionalsSection_pros-section__msp-badge--hidden__gztNl {
  visibility: hidden;
}
.ProfessionalsSection_pros-section__card-cta__lEkSF {
  position: absolute;
  left: 50%;
  bottom: 116px;
  transform: translateX(-50%) translateY(8px);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 40px;
  padding: 0 16px;
  border-radius: 14px;
  font-size: 13px;
  font-weight: 800;
  text-decoration: none;
  color: #13231D;
  background: rgba(247, 245, 241, 0.97);
  border: 1px solid rgba(12, 36, 28, 0.08);
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.18);
  opacity: 0;
  transition: opacity 0.18s ease, transform 0.18s ease, background 0.15s ease;
  pointer-events: auto;
  white-space: nowrap;
  z-index: 10;
}
.ProfessionalsSection_pros-section__card-cta__lEkSF:hover {
  background: #F7F5F1;
}
.ProfessionalsSection_pros-section__arrow__P8zpO {
  position: absolute;
  top: calc(50% - 12px);
  transform: translateY(-50%);
  z-index: 6;
  width: 42px;
  height: 42px;
  border-radius: 14px;
  border: 1px solid rgba(16, 25, 21, 0.1);
  background: rgba(247, 245, 241, 0.96);
  color: rgba(19, 35, 29, 0.82);
  font-size: 22px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.ProfessionalsSection_pros-section__arrow--left__roF0V {
  left: 18px;
}
.ProfessionalsSection_pros-section__arrow--right__mILnl {
  right: 18px;
}
.ProfessionalsSection_pros-section__arrow__P8zpO:hover {
  background: #F7F5F1;
}
@media (max-width: 768px) {
  .ProfessionalsSection_pros-section__arrow__P8zpO {
    display: none;
  }
}
.ProfessionalsSection_pros-section__arrow__P8zpO:disabled {
  opacity: 0.3;
  cursor: default;
}
.ProfessionalsSection_pros-section__dots__La-CS {
  display: flex;
  justify-content: center;
  gap: 7px;
  margin-top: 12px;
}
.ProfessionalsSection_pros-section__dot__k-4wm {
  width: 7px;
  height: 7px;
  border-radius: 999px;
  border: 0;
  padding: 0;
  background: rgba(19, 35, 29, 0.2);
  cursor: pointer;
  transition: all 0.3s;
}
.ProfessionalsSection_pros-section__dot--active__Wo17O {
  width: 20px;
  background: #82B194;
  border-radius: 10px;
}
.ProfessionalsSection_pros-section__msp-tag__O8w3U {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(255, 255, 255, 0.4);
  border-radius: 12px;
  padding: 2px 8px;
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-top: 8px;
  width: fit-content;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/components/Landing/ProfessionalsSection/ProfessionalsSection.module.scss"],"names":[],"mappings":"AAyIA;EACI,kBAAA;EACA,2CAAA;EACA,0CAAA;EACA,qBAAA;EAEA,wBAAA;EACA,sBAAA;EACA,qBAAA;EACA,qBAAA;EAGA,qCAAA;EACA,oCAAA;EAEA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,4BAAA;EAEA,iDAAA;AC7IJ;;AAdA;EACE,kBAAA;EACA,6BAAA;EACA,iBAAA;EACA,cAAA;EACA,oFDDU;ACkBZ;AAfE;EAPF;IAQI,kBAAA;EAkBF;AACF;AAhBE;EAXF;IAYI,kBAAA;EAmBF;AACF;AAjBE;EACE,mBAAA;EACA,yBAAA;EACA,8CAAA;EACA,uBAAA;EACA,aAAA;EACA,sBAAA;AAmBJ;AAjBI;EARF;IASI,uBAAA;EAoBJ;AACF;AAjBE;EACE,cAAA;EACA,eDQgB;ECPhB,gBAAA;EACA,cDtBmB;ECuBnB,sBAAA;EACA,mBAAA;EACA,yBAAA;EACA,iBAAA;AAmBJ;AAhBE;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;AAkBJ;AAhBI;EAPF;IAQI,eDZmB;ICanB,mBAAA;EAmBJ;AACF;AAhBE;EACE,cAAA;EACA,mBAAA;AAkBJ;AAhBI;EAJF;IAKI,mBAAA;EAmBJ;AACF;AAhBE;EACE,eAAA;EACA,iBAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;AAkBJ;AAfE;EACE,aAAA;EACA,yBAAA;EACA,iBAAA;AAiBJ;AAfI;EALF;IAMI,cAAA;IACA,cAAA;IACA,2BAAA;IACA,gBAAA;EAkBJ;AACF;AAfE;EACE,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,2CAAA;EACA,uBAAA;EACA,6BAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,gBAAA;EACA,eAAA;EACA,uBAAA;EACA,gBAAA;AAiBJ;AAfI;EAfF;IAgBI,WAAA;IACA,gBAAA;EAkBJ;AACF;AAhBI;EACE,oCAAA;EACA,sCAAA;AAkBN;AAbE;EACE,iBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,wCAAA;EACA,qCAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,2CAAA;AAeJ;AAZI;EAbF;IAcI,uBAAA;EAeJ;AACF;AAbI;EAjBF;IAkBI,aAAA;IACA,oBAAA;IACA,wBAAA;IACA,gBAAA;IACA,iBAAA;IACA,kBAAA;IACA,uBAAA;IACA,gBAAA;EAgBJ;AACF;AAbE;EACE,aAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,uBAAA;EACA,6BAAA;EACA,UAAA;EACA,SAAA;EACA,qBAAA;AAeJ;AAbI;EACE,aAAA;AAeN;AAXE;EACE,kBAAA;EACA,YAAA;EAAA,cAAA;EAAA,mCAAA;EACA,kCAAA;EACA,aAAA;EACA,wBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,8CAAA;EACA,eAAA;AAaJ;AAXI;EAZF;IAaI,mCAAA;IACA,kCAAA;EAcJ;AACF;AAZI;EAjBF;IAkBI,mCAAA;IACA,kCAAA;EAeJ;AACF;AAbI;EAtBF;IAuBI,gBAAA;IACA,eAAA;IACA,aAAA;EAgBJ;AACF;AAdI;EA5BF;IA6BI,aAAA;IACA,gBAAA;IACA,eAAA;IACA,yBAAA;EAiBJ;AACF;AAfI;EACE,aAAA;AAiBN;AAdI;EAEE,UAAA;EACA,yCAAA;AAeN;AAXE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,qEAAA;EACA,6BAAA;EACA,2EAAA;EACA,0BAAA;AAaJ;AAVE;EACE,kBAAA;EACA,QAAA;EACA,sBAAA;EACA,2BAAA;EACA,qCAAA;AAYJ;AAVI;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,mIAAA;AAYN;AARE;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;EACA,yBAAA;EACA,6BAAA;EACA,oBAAA;AAUJ;AAPE;EACE,kBAAA;EACA,SAAA;EACA,aAAA;EACA,2CAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,cDpPmB;ECqPnB,qCAAA;EACA,wCAAA;EACA,0CAAA;EACA,UAAA;EACA,2EAAA;EACA,oBAAA;EACA,mBAAA;EACA,WAAA;AASJ;AAPI;EACE,mBDpQiB;AC6QvB;AALE;EACE,UAAA;EACA,yCAAA;AAOJ;AAJE;EACE,kBAAA;EACA,SAAA;EACA,aAAA;EACA,2CAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,cDtRmB;ECuRnB,qCAAA;EACA,wCAAA;EACA,0CAAA;EACA,UAAA;EACA,2EAAA;EACA,oBAAA;EACA,mBAAA;EACA,WAAA;AAMJ;AAJI;EACE,mBDtSiB;AC4SvB;AAFE;EACE,UAAA;EACA,yCAAA;AAIJ;AADE;EACE,kBAAA;EACA,SAAA;EACA,aAAA;EACA,2CAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,cDxTmB;ECyTnB,qCAAA;EACA,wCAAA;EACA,0CAAA;EACA,UAAA;EACA,2EAAA;EACA,oBAAA;EACA,mBAAA;EACA,WAAA;AAGJ;AADI;EACE,mBDxUiB;AC2UvB;AACE;EACE,UAAA;EACA,yCAAA;AACJ;AAEE;EACE,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;AAAJ;AAGE;EACE,SAAA;EACA,gBAAA;EACA,aAAA;EACA,qBAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,2CAAA;AADJ;AAIE;EACE,eAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,gCAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,2CAAA;AAFJ;AAKE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,oBAAA;EACA,2CAAA;EACA,+BAAA;EACA,WAAA;EACA,cAAA;EACA,cAAA;EACA,gBAAA;EACA,sBAAA;EACA,0BAAA;AAHJ;AAKI;EACE,kBAAA;AAHN;AAOE;EACE,kBAAA;EACA,SAAA;EACA,aAAA;EACA,2CAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,cDtZmB;ECuZnB,qCAAA;EACA,wCAAA;EACA,0CAAA;EACA,UAAA;EACA,2EAAA;EACA,oBAAA;EACA,mBAAA;EACA,WAAA;AALJ;AAOI;EACE,mBDtaiB;ACiavB;AASE;EACE,kBAAA;EACA,qBAAA;EACA,2BAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,uCAAA;EACA,qCAAA;EACA,6BAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AAPJ;AASI;EACE,UAAA;AAPN;AAUI;EACE,WAAA;AARN;AAWI;EACE,mBDrciB;AC4bvB;AAYI;EA9BF;IA+BI,aAAA;EATJ;AACF;AAWI;EACE,YAAA;EACA,eAAA;AATN;AAaE;EACE,aAAA;EACA,uBAAA;EACA,QAAA;EACA,gBAAA;AAXJ;AAcE;EACE,UAAA;EACA,WAAA;EACA,oBAAA;EACA,SAAA;EACA,UAAA;EACA,iCAAA;EACA,eAAA;EACA,oBAAA;AAZJ;AAcI;EACE,WAAA;EACA,mBD7eiB;EC8ejB,mBAAA;AAZN;AAgBE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,0CAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,eAAA;EACA,kBAAA;AAdJ","sourcesContent":["\n// =============================================================================\n// BODHIWELL DESIGN TOKENS\n// =============================================================================\n\n// FONTS\n$font-main: \"Sora\", system-ui, -apple-system, \"Segoe UI\", Roboto, Arial, sans-serif;\n$font-accent: $font-main;\n\n\n// Brand Colors\n$color-primary:        #82B194; // CTA principal, estados activos y acentos del sistema.\n$color-primary-hover:  #739F84;\n$color-primary-active: #678F77;\n$color-gold:           #D6A640;  // Acento complementario para journeys, hitos y estados destacados dentro del dashboard.\n$color-gold-soft:      rgba(214, 166, 64, 0.10);\n\n// Backgrounds & Surfaces\n$color-bg:             #EFF0EC; // Fondo general del sistema y de ejemplos.\n$color-surface:        #F7F5F1; // Superficie oficial para cards, modales y contenedores principales del sistema.\n$color-surface-soft:   #F8F6F2; // Variante suave para interiores, previews, campos y superficies secundarias.\n$color-border:         rgba(16, 25, 21, 0.08); \n\n// Text Colors\n$text-main:            #13231D; // Titulares, labels y acciones principales. Color principal para títulos, cuerpo y acciones prioritarias. \n$text-muted:           #5F726B;\n$text-secondary:       rgba(19,35,29,.68); // Textos de apoyo, descripciones, subtítulos y metadata.\n$text-tertiary:        rgba(19,35,29,.46);  // Footer, placeholders y elementos de menor jerarquía visual.\n\n// Status Colors\n$color-error:          #C95C5C; // Mensajes de validación, borde error y helper error.\n\n\n// Font Sizes\n$font-size-h1:      64px; \n$font-size-h2:      48px; \n$font-size-h3:      24px; \n$font-size-title-mobile: 32px; \n$font-size-body:    16px; \n$font-size-small:   14px; \n$font-size-caption: 13px; \n\n$font-size-section-titles: $font-size-h2; \n$font-size-section-subtitles: $font-size-h3;\n$font-size-section-descripcion: $font-size-body;\n\n$radius-nav:    12px;  // Navegación del manual, tabs suaves y acciones de baja jerarquía.\n$radius-sm:     14px;  // Botones de soporte, badges rectangulares y accesos rápidos.\n$radius-md:     16px;  // Botones principales, inputs, CTA sobre imagen y controles activos.\n$radius-lg:     18px;  // Cards internas, previews, notas y paneles secundarios.\n$radius-xl:     24px;  // Cards principales del manual, modales y contenedores base del sistema.\n$radius-pill:   999px; // Tags de dimensión, chips y elementos totalmente redondeados.\n\n$border-radius: $radius-md;\n$btn-radius:    $radius-pill;\n\n// --- 5. SPACING SCALE ---\n$space-4:  4px;\n$space-8:  8px;\n$space-12: 12px;\n$space-16: 16px;\n$space-24: 24px;\n$space-32: 32px;\n$space-48: 48px;\n\n// --- 6. SHADOWS ---\n$shadow-card: 0 10px 30px rgba(0, 0, 0, 0.03); \n\n$header-height:       64px;\n$sidebar-width-open:  240px;\n$sidebar-width-closed: 80px;\n$submenu-panel-width: 280px;\n\n$transition-speed:    0.3s;\n\n$breakpoint-sm:       576px;\n$breakpoint-md:       768px;\n$breakpoint-lg:       992px;\n$breakpoint-desktop:  1024px;\n\n$base-container:1280px;\n$gutter-desktop:40px;\n$gutter-tablet:28px;\n$gutter-mobile:20px;\n\n$border-soft:rgba(19,35,29,.08);\n$border-mid:rgba(19,35,29,.22);\n\n$radius-card:32px;\n$radius-card-sm:24px;\n$radius-button:20px;\n$radius-button-header:18px;\n\n$shadow-soft:0 18px 48px rgba(18,34,29,.04);\n\n$sidebar-bg:           $color-surface;\n$sidebar-submenu-bg:   #ffffff;\n$sidebar-text-color:   $text-main;\n$sidebar-active-bg:    rgba($color-primary, 0.1);\n$sidebar-active-text:  $color-primary;\n\n\n// Mixins para Tipografía\n@mixin h1 {\n    font-size: 64px;\n    line-height: 1.0;\n    font-weight: 700;\n    letter-spacing: -0.045em;\n}\n\n@mixin h2 {\n    font-size: 48px;\n    line-height: 1.04;\n    font-weight: 800;\n    letter-spacing: -0.035em;\n}\n\n@mixin h3 {\n    font-size: 24px;\n    line-height: 1.28;\n    font-weight: 600;\n    letter-spacing: -0.015em;\n}\n\n@mixin body-text {\n    font-size: 16px;\n    line-height: 1.65;\n    font-weight: 400;\n}\n\n@mixin small-text {\n    font-size: 14px;\n    line-height: 1.5;\n    font-weight: 400;\n}\n\n\n:root {\n    --bw-text: #{$text-main};\n    --bw-text-secondary: #{$text-secondary};\n    --bw-text-tertiary: #{$text-tertiary};\n    --bw-primary: #{$color-primary};\n\n    --base-container: #{$base-container};\n    --gutter-desktop: #{$gutter-desktop};\n    --gutter-tablet: #{$gutter-tablet};\n    --gutter-mobile: #{$gutter-mobile};\n\n\n    --border-soft: #{$border-soft};\n    --border-mid: #{$border-mid};\n\n    --radius-card: #{$radius-card};\n    --radius-card-sm: #{$radius-card-sm};\n    --radius-button: #{$radius-button};\n    --radius-button-header: #{$radius-button-header};\n\n    --shadow-soft: #{$shadow-soft};\n\n}\n\n//Notes\n//El color oficial de card queda formalizado como --bw-card-surface con valor #F7F5F1. \n//Su variante complementaria --bw-card-surface-soft usa #F8F6F2 para superficies internas, previews y contenedores suaves.","@import '../../../assets/styles/variables';\n\n.pros-section {\n  padding: 72px 40px;\n  background-color: transparent;\n  max-width: 1280px;\n  margin: 0 auto;\n  font-family: $font-main;\n\n  @media (max-width: 1024px) {\n    padding: 48px 40px;\n  }\n\n  @media (max-width: 768px) {\n    padding: 40px 20px;\n  }\n\n  &__card {\n    border-radius: 16px;\n    background-color: #F7F5F1;\n    box-shadow: 0 12px 28px rgba(14, 42, 34, 0.08);\n    padding: 52px 56px 36px;\n    display: flex;\n    flex-direction: column;\n\n    @media (max-width: 768px) {\n      padding: 32px 20px 24px;\n    }\n  }\n\n  &__eyebrow {\n    display: block;\n    font-size: $font-size-caption;\n    font-weight: 700;\n    color: $color-primary-hover;\n    letter-spacing: 0.14em;\n    margin-bottom: 12px;\n    text-transform: uppercase;\n    line-height: 1.35;\n  }\n\n  &__title {\n    font-weight: 800;\n    font-size: 48px;\n    line-height: 1.04;\n    margin-bottom: 20px;\n    color: #3B3B3D;\n\n    @media (max-width: $breakpoint-md) {\n      font-size: $font-size-title-mobile;\n      margin-bottom: 16px;\n    }\n  }\n\n  &__title-line {\n    display: block;\n    white-space: nowrap;\n\n    @media (max-width: 768px) {\n      white-space: normal;\n    }\n  }\n\n  &__copy {\n    font-size: 16px;\n    line-height: 1.65;\n    color: #4A4A4A;\n    margin-top: 0;\n    margin-bottom: 0;\n    max-width: 700px;\n  }\n\n  &__action-row {\n    display: flex;\n    justify-content: flex-end;\n    grid-column: 1 / -1;\n\n    @media (max-width: 980px) {\n      grid-column: 1;\n      grid-row: auto;\n      justify-content: flex-start;\n      margin-top: 18px;\n    }\n  }\n\n  &__btn-secondary {\n    min-width: 300px;\n    min-height: 46px;\n    border-radius: 16px;\n    border: 1px solid rgba(130, 177, 148, 0.55);\n    background: transparent;\n    color: rgba(16, 25, 21, 0.84);\n    font-weight: 700;\n    cursor: pointer;\n    transition: all 0.2s;\n    line-height: 1.2;\n    font-size: 15px;\n    letter-spacing: -.01em;\n    margin-top: 16px;\n\n    @media (max-width: 1080px) {\n      width: 100%;\n      min-width: unset;\n    }\n\n    &:hover {\n      background: rgba(130, 177, 148, 0.1);\n      border-color: rgba(130, 177, 148, 0.7);\n    }\n  }\n\n\n  &__carousel {\n    grid-column: 1 / -1;\n    width: 100%;\n    margin-top: 28px;\n    position: relative;\n    border: 1px solid rgba(12, 36, 28, 0.08);\n    background: rgba(255, 255, 255, 0.36);\n    border-radius: 24px;\n    padding: 28px 32px 24px;\n    overflow: hidden;\n    box-shadow: 0 10px 30px rgba(0, 0, 0, .03);\n    ;\n\n    @media (max-width: 1024px) {\n      padding: 24px 24px 20px;\n    }\n\n    @media (max-width: 768px) {\n      padding: 20px;\n      margin: 20px -20px 0;\n      width: calc(100% + 40px);\n      border-radius: 0;\n      border-left: none;\n      border-right: none;\n      background: transparent;\n      box-shadow: none;\n    }\n  }\n\n  &__track {\n    display: flex;\n    gap: 16px;\n    overflow-x: auto;\n    overflow-y: hidden;\n    scroll-behavior: smooth;\n    scroll-snap-type: x mandatory;\n    padding: 0;\n    margin: 0;\n    scrollbar-width: none;\n\n    &::-webkit-scrollbar {\n      display: none;\n    }\n  }\n\n  &__pro-card {\n    position: relative;\n    flex: 0 0 calc((100% - 48px) / 4);\n    min-width: calc((100% - 48px) / 4);\n    height: 360px;\n    scroll-snap-align: start;\n    border-radius: 24px;\n    overflow: hidden;\n    background: #ddd;\n    box-shadow: 0 12px 28px rgba(14, 42, 34, 0.08);\n    cursor: pointer;\n\n    @media (max-width: 1180px) {\n      flex-basis: calc((100% - 32px) / 3);\n      min-width: calc((100% - 32px) / 3);\n    }\n\n    @media (max-width: 980px) {\n      flex-basis: calc((100% - 16px) / 2);\n      min-width: calc((100% - 16px) / 2);\n    }\n\n    @media (max-width: 780px) {\n      flex-basis: 82vw;\n      min-width: 82vw;\n      height: 400px;\n    }\n\n    @media (max-width: 768px) {\n      height: 420px;\n      flex-basis: 100%;\n      min-width: 100%;\n      scroll-snap-align: center;\n    }\n\n    &::before {\n      content: none;\n    }\n\n    &:hover &__card-cta,\n    &:focus-within &__card-cta {\n      opacity: 1;\n      transform: translateX(-50%) translateY(0);\n    }\n  }\n\n  &__dim-tag {\n    position: absolute;\n    top: 14px;\n    left: 14px;\n    z-index: 5;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    min-height: 28px;\n    padding: 0 10px;\n    border-radius: 999px;\n    font-size: 11px;\n    font-weight: 700;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n    background: color-mix(in srgb, var(--dimension-color) 14%, white 86%);\n    color: var(--dimension-color);\n    border: 1px solid color-mix(in srgb, var(--dimension-color) 32%, white 68%);\n    backdrop-filter: blur(4px);\n  }\n\n  &__pro-media {\n    position: absolute;\n    inset: 0;\n    background-size: cover;\n    background-position: center;\n    filter: saturate(0.94) contrast(1.04);\n\n    &::after {\n      content: \"\";\n      position: absolute;\n      inset: 0;\n      background: linear-gradient(to top, rgba(0, 0, 0, 0.84) 0%, rgba(0, 0, 0, 0.58) 24%, rgba(0, 0, 0, 0.22) 52%, rgba(0, 0, 0, 0) 76%);\n    }\n  }\n\n  &__pro-overlay {\n    position: absolute;\n    left: 16px;\n    right: 16px;\n    bottom: 26px;\n    z-index: 4;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 12px;\n    justify-content: flex-end;\n    min-height: calc(100% - 32px);\n    pointer-events: none;\n  }\n\n  &__card-cta {\n    position: absolute;\n    left: 50%;\n    bottom: 116px;\n    transform: translateX(-50%) translateY(8px);\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    min-height: 40px;\n    padding: 0 16px;\n    border-radius: 14px;\n    font-size: 13px;\n    font-weight: 800;\n    text-decoration: none;\n    color: $text-main;\n    background: rgba(247, 245, 241, 0.97);\n    border: 1px solid rgba(12, 36, 28, 0.08);\n    box-shadow: 0 8px 18px rgba(0, 0, 0, 0.18);\n    opacity: 0;\n    transition: opacity 0.18s ease, transform 0.18s ease, background 0.15s ease;\n    pointer-events: auto;\n    white-space: nowrap;\n    z-index: 10;\n\n    &:hover {\n      background: $color-surface;\n    }\n  }\n\n  &__pro-card:hover &__card-cta {\n    opacity: 1;\n    transform: translateX(-50%) translateY(0);\n  }\n\n  &__card-cta {\n    position: absolute;\n    left: 50%;\n    bottom: 116px;\n    transform: translateX(-50%) translateY(8px);\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    min-height: 40px;\n    padding: 0 16px;\n    border-radius: 14px;\n    font-size: 13px;\n    font-weight: 800;\n    text-decoration: none;\n    color: $text-main;\n    background: rgba(247, 245, 241, 0.97);\n    border: 1px solid rgba(12, 36, 28, 0.08);\n    box-shadow: 0 8px 18px rgba(0, 0, 0, 0.18);\n    opacity: 0;\n    transition: opacity 0.18s ease, transform 0.18s ease, background 0.15s ease;\n    pointer-events: auto;\n    white-space: nowrap;\n    z-index: 10;\n\n    &:hover {\n      background: $color-surface;\n    }\n  }\n\n  &__pro-card:hover &__card-cta {\n    opacity: 1;\n    transform: translateX(-50%) translateY(0);\n  }\n\n  &__card-cta {\n    position: absolute;\n    left: 50%;\n    bottom: 116px;\n    transform: translateX(-50%) translateY(8px);\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    min-height: 40px;\n    padding: 0 16px;\n    border-radius: 14px;\n    font-size: 13px;\n    font-weight: 800;\n    text-decoration: none;\n    color: $text-main;\n    background: rgba(247, 245, 241, 0.97);\n    border: 1px solid rgba(12, 36, 28, 0.08);\n    box-shadow: 0 8px 18px rgba(0, 0, 0, 0.18);\n    opacity: 0;\n    transition: opacity 0.18s ease, transform 0.18s ease, background 0.15s ease;\n    pointer-events: auto;\n    white-space: nowrap;\n    z-index: 10;\n\n    &:hover {\n      background: $color-surface;\n    }\n  }\n\n  &__pro-card:hover &__card-cta {\n    opacity: 1;\n    transform: translateX(-50%) translateY(0);\n  }\n\n  &__pro-copy {\n    min-height: 104px;\n    margin-top: auto;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-end;\n  }\n\n  &__pro-name {\n    margin: 0;\n    min-height: 48px;\n    display: flex;\n    align-items: flex-end;\n    color: #fff;\n    font-size: 22px;\n    line-height: 1.08;\n    font-weight: 700;\n    letter-spacing: -0.01em;\n    text-shadow: 0 8px 16px rgba(0, 0, 0, 0.34);\n  }\n\n  &__pro-role {\n    margin: 6px 0 0;\n    min-height: 30px;\n    display: flex;\n    align-items: flex-start;\n    color: rgba(255, 255, 255, 0.94);\n    font-size: 12px;\n    line-height: 1.25;\n    font-weight: 600;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n    text-shadow: 0 8px 16px rgba(0, 0, 0, 0.34);\n  }\n\n  &__msp-badge {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    align-self: flex-start;\n    width: auto;\n    min-width: 0;\n    margin-top: 10px;\n    min-height: 20px;\n    padding: 0 8px;\n    border-radius: 999px;\n    border: 1px solid rgba(255, 255, 255, 0.42);\n    background: rgba(0, 0, 0, 0.18);\n    color: #fff;\n    font-size: 9px;\n    line-height: 1;\n    font-weight: 800;\n    letter-spacing: 0.02em;\n    backdrop-filter: blur(6px);\n\n    &--hidden {\n      visibility: hidden;\n    }\n  }\n\n  &__card-cta {\n    position: absolute;\n    left: 50%;\n    bottom: 116px;\n    transform: translateX(-50%) translateY(8px);\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    min-height: 40px;\n    padding: 0 16px;\n    border-radius: 14px;\n    font-size: 13px;\n    font-weight: 800;\n    text-decoration: none;\n    color: $text-main;\n    background: rgba(247, 245, 241, 0.97);\n    border: 1px solid rgba(12, 36, 28, 0.08);\n    box-shadow: 0 8px 18px rgba(0, 0, 0, 0.18);\n    opacity: 0;\n    transition: opacity 0.18s ease, transform 0.18s ease, background 0.15s ease;\n    pointer-events: auto;\n    white-space: nowrap;\n    z-index: 10;\n\n    &:hover {\n      background: $color-surface;\n    }\n  }\n\n  &__arrow {\n    position: absolute;\n    top: calc(50% - 12px);\n    transform: translateY(-50%);\n    z-index: 6;\n    width: 42px;\n    height: 42px;\n    border-radius: 14px;\n    border: 1px solid rgba(16, 25, 21, 0.10);\n    background: rgba(247, 245, 241, 0.96);\n    color: rgba(19, 35, 29, 0.82);\n    font-size: 22px;\n    line-height: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n\n    &--left {\n      left: 18px;\n    }\n\n    &--right {\n      right: 18px;\n    }\n\n    &:hover {\n      background: $color-surface;\n    }\n\n    @media (max-width: 768px) {\n      display: none;\n    }\n\n    &:disabled {\n      opacity: 0.3;\n      cursor: default;\n    }\n  }\n\n  &__dots {\n    display: flex;\n    justify-content: center;\n    gap: 7px;\n    margin-top: 12px;\n  }\n\n  &__dot {\n    width: 7px;\n    height: 7px;\n    border-radius: 999px;\n    border: 0;\n    padding: 0;\n    background: rgba(19, 35, 29, 0.20);\n    cursor: pointer;\n    transition: all 0.3s;\n\n    &--active {\n      width: 20px;\n      background: $color-primary;\n      border-radius: 10px;\n    }\n  }\n\n  &__msp-tag {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    border: 1px solid rgba(255, 255, 255, 0.4);\n    border-radius: 12px;\n    padding: 2px 8px;\n    color: #fff;\n    font-size: 10px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    margin-top: 8px;\n    width: fit-content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pros-section": `ProfessionalsSection_pros-section__n7H2i`,
	"pros-section__card": `ProfessionalsSection_pros-section__card__IIEI9`,
	"pros-section__eyebrow": `ProfessionalsSection_pros-section__eyebrow__Fhq-S`,
	"pros-section__title": `ProfessionalsSection_pros-section__title__flfqe`,
	"pros-section__title-line": `ProfessionalsSection_pros-section__title-line__h3Ipt`,
	"pros-section__copy": `ProfessionalsSection_pros-section__copy__CLeWP`,
	"pros-section__action-row": `ProfessionalsSection_pros-section__action-row__DrbSf`,
	"pros-section__btn-secondary": `ProfessionalsSection_pros-section__btn-secondary__KqYof`,
	"pros-section__carousel": `ProfessionalsSection_pros-section__carousel__5jH5i`,
	"pros-section__track": `ProfessionalsSection_pros-section__track__4w20C`,
	"pros-section__pro-card": `ProfessionalsSection_pros-section__pro-card__Raq-f`,
	"pros-section__pro-card__card-cta": `ProfessionalsSection_pros-section__pro-card__card-cta__BJ9-7`,
	"pros-section__dim-tag": `ProfessionalsSection_pros-section__dim-tag__uHWr4`,
	"pros-section__pro-media": `ProfessionalsSection_pros-section__pro-media__UNrHM`,
	"pros-section__pro-overlay": `ProfessionalsSection_pros-section__pro-overlay__iqriY`,
	"pros-section__card-cta": `ProfessionalsSection_pros-section__card-cta__lEkSF`,
	"pros-section__pro-copy": `ProfessionalsSection_pros-section__pro-copy__6HY5A`,
	"pros-section__pro-name": `ProfessionalsSection_pros-section__pro-name__YrPIo`,
	"pros-section__pro-role": `ProfessionalsSection_pros-section__pro-role__ETxsH`,
	"pros-section__msp-badge": `ProfessionalsSection_pros-section__msp-badge__aZdJA`,
	"pros-section__msp-badge--hidden": `ProfessionalsSection_pros-section__msp-badge--hidden__gztNl`,
	"pros-section__arrow": `ProfessionalsSection_pros-section__arrow__P8zpO`,
	"pros-section__arrow--left": `ProfessionalsSection_pros-section__arrow--left__roF0V`,
	"pros-section__arrow--right": `ProfessionalsSection_pros-section__arrow--right__mILnl`,
	"pros-section__dots": `ProfessionalsSection_pros-section__dots__La-CS`,
	"pros-section__dot": `ProfessionalsSection_pros-section__dot__k-4wm`,
	"pros-section__dot--active": `ProfessionalsSection_pros-section__dot--active__Wo17O`,
	"pros-section__msp-tag": `ProfessionalsSection_pros-section__msp-tag__O8w3U`
};
export default ___CSS_LOADER_EXPORT___;
